import { AuditEntity } from "@app/common";
import { ContractStatus } from "@app/orders-base";
import { ProductCategory, ProductType, ResellerProductType, TariffChangeType } from "@app/products-base";
import { Column, Display, EnumPipe, EnumService, Table } from "@messaia/cdk";

@Table({
    endpoint: 'contract',
    deletable: false,
    rowNgClass: (row: Contract) => {
        return { 'terminated': row.contractStatus == ContractStatus.Terminated };
    }
})
export class Contract extends AuditEntity {
    /**
     * @property
     */
    @Column({ filterOperator: '~', width: 70 })
    @Display($localize`:@@number:Number`)
    number: number;

    /**
     * @property
     */
    customerId: number | null;

    /**
     * @property
     */
    @Column({ showGtSm: true })
    @Display($localize`:@@firstName:First name`)
    firstName: string;

    /**
     * @property
     */
    @Column()
    @Display($localize`:@@lastName:Last name`)
    lastName: string;

    /**
     * @property
     */
    company: string;

    /**
     * @property
     */
    @Column({ showGtLg: true })
    @Display($localize`:@@address1:Address 1`)
    address1: string;

    /**
     * @property
     */
    @Column({ width: 50, showGtLg: true })
    @Display($localize`:@@address2:Address 2`)
    address2: string;

    /**
     * @property
     */
    @Column({ width: 80, showGtLg: true })
    @Display($localize`:@@address3:Address 3`)
    address3: string;

    /**
     * @property
     */
    @Column({ showGtXl: true })
    @Display($localize`:@@billingAddress:Billing address`)
    billingAddress: string;

    /**
     * @property
     */
    @Column({
        enumType: ContractStatus,
        cellNgClass: (row: Contract) => {
            return {
                'tc-orange-500': row.contractStatus == ContractStatus.New,
                'tc-green-500': row.contractStatus == ContractStatus.Active,
                'tc-black': row.contractStatus == ContractStatus.Cancelled,
                'tc-blue-500': row.contractStatus == ContractStatus.Terminated,
                'tc-red-500': row.contractStatus == ContractStatus.Completed
            }
        },
        width: 90,
        showGtLg: true
    })
    @Display($localize`:@@contractStatus:Contract status`)
    contractStatus: ContractStatus;

    /**
     * @property
     */
    provisionStatusId: number;

    /**
     * @property
     */
    @Column({
        endpoint: 'provisionStatus?enabled=true&projection=id,name',
        filter: 'provisionStatusId',
        width: 90,
        showGtXl: true
    })
    @Display($localize`:@@provStatus:Prov. status`)
    provisionStatus: string;

    /**
     * @property
     */
    @Column({
        options: EnumService.toArray(TariffChangeType),
        content: (row: Contract) => !row.tariffChangeType ? '' : new EnumPipe().transform(row.tariffChangeType, TariffChangeType),
        width: 70,
        showGtXl: true
    })
    @Display($localize`:@@tariffChangeType:Tariff change`)
    tariffChangeType: TariffChangeType;

    /**
     * @property
     */
    @Column({ showGtLg: true })
    @Display($localize`:@@tariff:Tariff`)
    tariffName: string;

    /**
     * @property
     */
    @Column({ showGtMd: true })
    @Display($localize`:@@product:Product`)
    productName: string;

    /**
     * @property
     */
    orderId: number | null;

    /**
     * @property
     */
    clientId: number | null;

    /**
     * @property
     */
    @Display($localize`:@@client:Client`)
    clientName: string;

    /**
     * @property
     */
    terminable: boolean;

    /**
     * @property
     */
    terminationRevocable: boolean;

    /**
     * @property
     */
    productCategory: ProductCategory;

    /**
     * @property
     */
    productType: ProductType;

    /**
     * @property
     */
    resellerProductType: ResellerProductType;
}